import { render } from "./AtribuirLocalizacao.vue?vue&type=template&id=6ceee87e&scoped=true"
import script from "./AtribuirLocalizacao.vue?vue&type=script&lang=js"
export * from "./AtribuirLocalizacao.vue?vue&type=script&lang=js"

import "./AtribuirLocalizacao.vue?vue&type=style&index=0&id=6ceee87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceee87e"]])

export default __exports__